<template>
    <div id="createUrlRedirModal" class="modal inmodal fade modal-v5" ref="createUrlRedirModal">
        <div class="modal-dialog modal-md">
            <div class="ba-card ba-w-50 ba-mg-t-4">
              <div class="ba-top ba-pd-x-2 ba-mg-t-2 ba-flex ba-jc-sb">
                  <div class="ba-title">
                    <span class="ba-color-blue19 ba-montserrat-600" style="font-size: 22px;" v-html="view.translations.redirect_link.link_generator"></span>
                  </div>
                  <div class="ba-box-items ba-flex ba-jc-fe">
                    <button type="button" class="ba-btn ba-btn-close ba-sm ba-rounded" data-dismiss="modal" aria-hidden="true">
                      <builderall-icon code="64f7" />
                    </button>
                  </div>
              </div>
              <builderall-loader :loading="loading">
              <div class="ba-content ba-pd-x-2 ba-mg-b-2">
                <div class="ba-pd-t-1 ba-mg-r-1">
                  <span class="ba-montserrat-500" style="font-size: 14px;" v-html="view.translations.redirect_link.info_redirect_link_modal"></span>
                </div>
                <form role="form" action="#" id="create-url-redir">
                  <div class="ba-box-input ba-w-100 ba-mg-t-2">
                    <div class="ba-info">
                        <div class="ba-info-left">
                            <label class="ba-label" for="input_id" v-html="view.translations.redirect_link.office2_autopilot_share_urlredir_url1"></label>
                        </div>
                    </div>
                    <input
                        type="url"
                        name="url"
                        value=""
                        required="required"
                        class="ba-input"
                        placeholder="http://www.mysite.com"
                        v-model="userText"
                    />
                  </div>
                  <div class="ba-w-100">
                    <div class="ba-flex ba-jc-fe ba-mg-t-1">
                      <button class="ba-btn ba-lg ba-blue" type="submit" @click="go()">
                        <span class="ba-text-capitalize ba-montserrat-400 ba-pd-x-1" v-html="view.translations.redirect_link.button_enviar"></span>
                      </button>
                    </div>
                  </div>
                  <div v-if="showInputCopy" class="box-input-copy">
                      <div class="ba-box-input">
                          <div class="ba-info">
                              <div class="ba-info-left">
                                  <label class="ba-label" for="input_id" v-html="view.translations.redirect_link.office2_autopilot_share_urlredir_url2"></label>
                              </div>
                          </div>
                          <fs6-input-copy :view="[view.translations.redirect_link.your_link_here,destinataryUrl,view.translations.redirect_link.copied]"></fs6-input-copy>
                      </div>
                      <div v-if="can_access_short_url" class="ba-mg-t-1">
                        <div class="ba-box-input">
                          <div class="ba-info">
                              <div class="ba-info-left">
                                  <label class="ba-label" for="input_id" v-html="view.translations.redirect_link.office2_autopilot_share_modal_url_curta"></label>
                              </div>
                          </div>
                          <div v-if="showSelect" class="select-grid ba-w-100" id="share-url-select-mini" ref="share-url-select-mini">
                            <div class="ba-flex ba-w-100">
                              <select class="ba-select ba-lg ba-w-100" name="select" v-model="selectedShortUrl">
                                <option v-for="(url, index) in optionsSelectShortUrl" :key="index" :value="url">{{ url }}</option>
                              </select>
                              <button class="button-copy-shorter-link ba-mg-l-1">
                                <builderall-icon code="b54c" />
                              </button>
                              <input
                                  type="text"
                                  class="ba-input"
                                  :value="selectedShortUrl"
                                  id="share-url-input-hidden-mini"
                                  ref="share-url-input-hidden-mini"
                              />
                            </div>
                              <!-- <select name="select" class="form-control" v-model="selectedShortUrl">
                                <option v-for="(url, index) in optionsSelectShortUrl" :key="index" :value="url">{{url}}</option>
                              </select> -->
                              <!-- <fs5-button :label="view.translations.redirect_link.copy" :btn-type="'white'" :text-transform-type="'capitalize'" @clicked="copyToClipboard('share-url-input-hidden-mini', 'share-url-select-mini')"></fs5-button> -->
                              <!-- <input type="text" :value="selectedShortUrl" id="share-url-input-hidden-mini" ref="share-url-input-hidden-mini"/> -->
                          </div>
                          <div v-else class="short-url-loading">
                            <img v-show="showShortUrlLoad" src="/internacional/public/office4/img/dashboard/load-2.svg"/>
                            <div class="ba-w-100">
                              <div class="ba-alert ba-error" v-show="is_suspect">
                                <span>
                                  {{ view.translations.redirect_link.url_suspected_error }} <br />
                                  {{ view.translations.redirect_link.url_suspected_contact_support }}
                                </span>
                              </div>
                              <div class="ba-alert ba-error" v-show="showShortUrlError">
                                  <span>
                                    {{view.translations.redirect_link.error_loading_data+' '}}
                                    {{view.translations.redirect_link.try_again_later}} <br/>
                                    {{view.translations.redirect_link.contact_the_support}}
                                  </span>
                              </div>
                            </div>
                          </div>
                        </div>


                        <!-- <label class="title__submit__common input-share-label" v-html="view.translations.redirect_link.office2_autopilot_share_modal_url_curta"></label> -->
                          <!-- <input v-show="!showSelect" class="form-control redir-url-new input-share" type="text" value="" readonly id="share-url-input-mini" ref="share-url-input-mini" style="cursor: pointer;"> -->
                            <!-- <div v-if="showSelect" class="select-grid" id="share-url-select-mini" ref="share-url-select-mini">
                              <select name="select" class="form-control" v-model="selectedShortUrl">
                                <option v-for="(url, index) in optionsSelectShortUrl" :key="index" :value="url">{{url}}</option>
                              </select>
                              <fs5-button :label="view.translations.redirect_link.copy" :btn-type="'white'" :text-transform-type="'capitalize'" @clicked="copyToClipboard('share-url-input-hidden-mini', 'share-url-select-mini')"></fs5-button>
                              <input type="text" :value="selectedShortUrl" id="share-url-input-hidden-mini" ref="share-url-input-hidden-mini"/>
                            </div>
                            <div v-else class="short-url-loading">
                              <img v-show="showShortUrlLoad" src="/internacional/public/office4/img/dashboard/load-2.svg"/>
                              <span v-show="is_suspect">
                                <img src='/internacional/public/office5/img/general-png/Path.png'/>
                                  {{ view.translations.redirect_link.url_suspected_error }} <br />
                                  {{ view.translations.redirect_link.url_suspected_contact_support }}
                              </span>
                              <span v-show="showShortUrlError">
                                <img src='/internacional/public/office5/img/general-png/Path.png'/>
                                  {{view.translations.redirect_link.error_loading_data+' '}}
                                  {{view.translations.redirect_link.try_again_later}} <br/>
                                  {{view.translations.redirect_link.contact_the_support}}
                              </span>
                          </div> -->
                      </div>
                    </div>
                </form>
              </div>
              <!-- <div class="modal-header">
                    <fs5-collapse-info :view="[view.translations.redirect_link.office2_autopilot_share_urlredir,view.translations.redirect_link.info_redirect_link_modal]"></fs5-collapse-info>
                </div>
                <form role="form" action="#" id="create-url-redir">
                    <div class="modal-body scroll-x-auto">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label class="title__submit__common input-share-label" v-html="view.translations.redirect_link.office2_autopilot_share_urlredir_url1"></label>
                                    <br>
                                    <input type="url" class="form-control input-share" name="url" value="" required="required" placeholder="http://www.mysite.com" v-model="userText">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="box-inputs modal-body">
                        <div class="box-btn-link">
                            <button type="submit" class="btn btn-block is-primary btn-generator" @click="go()" :disabled="!userText || !validUrl">
                                <b v-if="!showIconAnimation" v-html="view.translations.redirect_link.button_enviar"></b>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                                </svg>
                            </button>
                            <div v-if="showInputCopy" class="box-input-copy">
                                <br>
                                <div>
                                    <label class="title__submit__common input-share-label" v-html="view.translations.redirect_link.office2_autopilot_share_urlredir_url2"></label>
                                    <fs5-input-copy :view="[view.translations.redirect_link.your_link_here,destinataryUrl,view.translations.redirect_link.copied]"></fs5-input-copy>
                                </div>
                                <br>
                                <div v-if="can_access_short_url">
                                    <label class="title__submit__common input-share-label" v-html="view.translations.redirect_link.office2_autopilot_share_modal_url_curta"></label> -->
                                    <!-- Essa linha ta comentada <input v-show="!showSelect" class="form-control redir-url-new input-share" type="text" value="" readonly id="share-url-input-mini" ref="share-url-input-mini" style="cursor: pointer;"> -->
                                    <!-- <div v-if="showSelect" class="select-grid" id="share-url-select-mini" ref="share-url-select-mini">
                                        <select name="select" class="form-control" v-model="selectedShortUrl">
                                            <option v-for="(url, index) in optionsSelectShortUrl" :key="index" :value="url">{{url}}</option>
                                        </select>
                                        <fs5-button :label="view.translations.redirect_link.copy" :btn-type="'white'" :text-transform-type="'capitalize'" @clicked="copyToClipboard('share-url-input-hidden-mini', 'share-url-select-mini')"></fs5-button>
                                        <input type="text" :value="selectedShortUrl" id="share-url-input-hidden-mini" ref="share-url-input-hidden-mini"/>
                                    </div>
                                    <div v-else class="short-url-loading">
                                      <img v-show="showShortUrlLoad" src="/internacional/public/office4/img/dashboard/load-2.svg"/>
                                      <span v-show="is_suspect">
                                        <img src='/internacional/public/office5/img/general-png/Path.png'/>
                                        {{ view.translations.redirect_link.url_suspected_error }} <br />
                                        {{ view.translations.redirect_link.url_suspected_contact_support }}
                                      </span>
                                      <span v-show="showShortUrlError">
                                        <img src='/internacional/public/office5/img/general-png/Path.png'/>
                                        {{view.translations.redirect_link.error_loading_data+' '}}
                                        {{view.translations.redirect_link.try_again_later}} <br/>
                                        {{view.translations.redirect_link.contact_the_support}}
                                      </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>-->
                <form :action="`${view.data.constList.host_short_url}/api/v1/list-url`" method="post" name="form-list-short-url" id="form-list-short-url" target="_blank">
                    <input type="hidden" name="user_id" :value="view.data.dados_usuario_office.id"/>
                    <input type="hidden" name="lang" :value="selectedLanguage"/>
                    <input type="hidden" id="token" name="token" value=""/>
                </form>
              </builderall-loader>
            </div>
        </div>
    </div>
</template>

<script>

import { url } from 'vuelidate/lib/validators';

    // new Clipboard('.copy');
    let language = new URL(location.href).searchParams.get('language');

    export default {
        props: [
            'accessShortUrlFunc',
            'can_access_short_url'
        ],
        name: 'modal-redirect-link-v5',
        data: function() {
            return {
                is_suspect: false,
                createUrlRedirModal: this.$refs.createUrlRedirModal,
                userLanguage: window.lang || 'us',
                selectedLanguage: language !== undefined && language !== null ? language : this.userLanguage,

                //data
                lang: window.lang || 'us',
                loading: true,
                showIconAnimation: false,
                showInputCopy: false,
                destinataryUrl: '',
                userText: '',
                validUrl: false,

                selectedShortUrl: '',
                optionsSelectShortUrl: [],
                showShortUrlLoad: true,
                showShortUrlError: false,
                showSelect: false,
                view: { // prevent undefined bugs
                    data: {
                        constList: {
                            affiliate_type_pro: '',
                            application_env: '',
                            ba_gateway_front: '',
                            host_short_url: ''
                        },
                        'dados_usuario_office': {
                            affiliate_type: '',
                            email: '',
                            id: ''
                        },
                        link_user: '',
                        access_short_url: '/us/office/url-shortener',
                    },
                    translations: {
                        redirect_link:{
                            button_enviar: '',
                            copied: '',
                            copy: '',
                            'error-url-invalida': '',
                            go_to_shorturl_dashboard: '',
                            office2_autopilot_share_modal_url_curta: '',
                            office2_autopilot_share_urlredir: '',
                            office2_autopilot_share_urlredir_url1: '',
                            office2_autopilot_share_urlredir_url2: '',
                        }
                    }
                },
            }
        },
        methods: {
            accessShortUrlFuncCall() {
                if(this.accessShortUrlFunc !== undefined && this.accessShortUrlFunc !== null) {
                    if( typeof this.accessShortUrlFunc == 'function' )
                    {
                        this.accessShortUrlFunc()
                    }
                    else { // just for calls outside a vue component
                       window.open(this.accessShortUrlFunc, '_blank')
                    }
                }
            },
            go() {
                if(!this.userText || !this.validUrl)
                {
                    alertMsg("error", view.translations.redirect_link.complete_correctly_field);
                }
                else
                {
                    //button animation
                    if(!this.showIconAnimation)
                    {
                        this.showIconAnimation = true;
                        setTimeout(() => {
                            this.showIconAnimation = false;
                            document.activeElement.blur();
                        }, 2000);
                    }
                    this.showInputCopy = true;
                }
            },
            copyToClipboard(element, elPopover) {
                let copyText = document.getElementById(element);
                copyText.select();
                document.execCommand("Copy");
                alertMsg("success",view.translations.redirect_link.copied);
            },
            canShortenURL(token, long_url, callback) {
              let vm = this
              axios.get(`https://urls.builderall.com/api/v1/url/is-suspect?long_url=${this.userText}`)
                .then(response => {
                  vm.is_suspect = response.data.data.is_suspect

                  if (!response.data.data.is_suspect) {
                    this.shortUrlBuilderall(token, long_url, callback)
                  } else {
                    vm.showSelect = false
                  }
                })
                .catch(error => {
                  console.error(error)
                  vm.showShortUrlError = true
                })
                .finally(() => {
                  vm.showShortUrlLoad = false
                })
            },
            shortUrlBuilderall(token, long_url, callback) {
                let vm = this
                let params = '?get-options=1';

                // Release new shortener link only to Released Accounts
                // Key defined in FranchiseModalsController.php class
                if(vm.view.data.is_release_account) {
                  params += '&context=office-redirect-link';
                }

                $.ajax({
                    url: `${vm.view.data.constList.host_short_url}/api/v1/create${params}`,
                    type: 'POST',
                    headers: {
                        'X-Token': token
                    },
                    data: {
                        'user_id': vm.view.data.dados_usuario_office.id,
                        'long_url': long_url
                    },
                    success(response) {
                        if (response.status == 'success')
                        {
                            if(response.options !== undefined && response.options !== null && response.options.length > 0)
                            {
                                vm.$set(vm.$data, 'optionsSelectShortUrl', response.options);
                                vm.showSelect = true;
                            }
                            else
                            {
                                vm.showSelect = false;
                            }
                            vm.selectedShortUrl = response.short_url;
                            vm.showShortUrlLoad = false;
                            callback(response);
                        }
                        else
                        {
                            if (!!response.error && response.error == 'long_url_not_valid_blacklist')
                            {
                                // alertMsg included on another global file
                                alertMsg('error', vm.view.translations.redirect_link.url_blacklisted);
                            }
                            else
                            {
                                // alertMsg included on another global file
                                alertMsg('error', response.message);
                            }
                            vm.showShortUrlBuilderallFeedbackError();
                        }
                    },
                    error: function(response) {
                        console.log(response);
                        vm.showShortUrlBuilderallFeedbackError();
                    }
                });
            },
            showShortUrlBuilderallFeedbackError() {
              this.showShortUrlLoad = false;
              this.showShortUrlError = true;
            },
            processResponsePublishShortUrl(response) {
                $('.new-url2').removeClass('hide');
                $('.redir-url-new').val(response.short_url);
            },
            forceInitRefs() {
                this.createUrlRedirModal = this.$refs.createUrlRedirModal
            },
            init: async function(params) {
                await this.requestDataLinkGenerators()
                this.forceInitRefs()

                let vm = this
                $('#share-url-input-big').popover({
                    title: '',
                    container: '#create-url-redir',
                    content: vm.view.translations.redirect_link.copied,
                    placement: 'left',
                    trigger: "manual"
                });

                $('#share-url-input-mini').popover({
                    title: '',
                    container: '#create-url-redir',
                    content: vm.view.translations.redirect_link.copied,
                    placement: 'left',
                    trigger: "manual"
                });


                $('#share-url-select-mini').popover({
                    title: '',
                    container: '#create-url-redir',
                    content: vm.view.translations.redirect_link.copied,
                    placement: 'left',
                    trigger: "manual"
                });

                $('#create-url-redir input[name="url"]').on('keyup', function(ev) {
                    var position = this.selectionStart;

                    this.value = $(this).val().toLowerCase();
                    this.selectionEnd = position;
                });

                $.validator.addMethod("regex", function(value, element, regexp) {
                    let re = new RegExp(regexp);
                    return this.optional(element) || re.test(value);
                }, vm.view.translations.redirect_link['error-url-invalida']);

                $.validator.addMethod("validateURL", function(value) {
                    try {
                        new URL(value);
                    } catch (e) {
                        return false;
                    }
                    return true;
                }, vm.view.translations.redirect_link['error-url-invalida']);

                $("#create-url-redir").validate({
                    rules: {
                        name: "required",
                        url: {
                            required: true,
                            url: false,
                            regex: '^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$',
                            validateURL: true
                        }
                    },
                    submitHandler: function(form2) {
                        let form = $(form2);
                        let url = $("input[name='url']", form).val();

                        // redir builderall.com to builderall-offer.com rule
                        if(
                            !! url.match(/^(http|https):\/\/builderall.com/i) ||
                            !! url.match(/^(http|https):\/\/www.builderall.com/i)
                        )
                        {
                            url = url.replace('builderall.com', 'builderall-offer.com');
                        }

                        if( vm.view.data.user_domain_share && vm.view.data.user_domain_share.length > 0)
                        {
                            url = `${vm.view.data.link_user}?lt_url=${encodeURIComponent(url)}`;
                        }
                        else
                        {
                            url = `${vm.view.data.link_user}?p1=rd&p2=${encodeURIComponent(url)}`;
                        }

                        vm.destinataryUrl = url;

                        let box = $('.new-url', form);
                        box.removeClass('hide');

                        $('input', box).val(url).select();

                        try {
                          $.ajax({
                            url: `${vm.view.data.constList.url_office}/us/office/url-shortener/auth`,
                            data    : '',
                            method  : 'GET',
                            headers : {
                                'X-Requested-With' : 'XMLHttpRequest',
                            },
                            success: function(response) {
                                if (response.status == 'success')
                                {
                                    let token = response.token;
                                    vm.canShortenURL(token, url, vm.processResponsePublishShortUrl)
                                }
                                else
                                {
                                    // alertMsg included on another global file
                                    alertMsg('error', 'Error generate short url token!');
                                    vm.showShortUrlBuilderallFeedbackError();
                                }
                            },
                            error: function(response) {
                                vm.showShortUrlBuilderallFeedbackError();
                                console.log(response);
                            }
                          });
                        }
                        catch(e) {
                          vm.showShortUrlBuilderallFeedbackError();
                        }
                    },
                    highlight: function ( element, errorClass, validClass ) {
                        if( $(element).is("input") )
                        {
                            vm.validUrl = false;
                            $(element).removeClass('valid');
                            $(element).closest('.form-group').addClass('has-error');
                        }
                    },
                    unhighlight: function ( element, errorClass, validClass ) {
                        if( $(element).is("input") )
                        {
                            vm.validUrl = true;
                            $(element).addClass('valid');
                            $(element).closest('.form-group').removeClass('has-error');
                        }
                    }
                });

                $("input[name='url']", vm.createUrlRedirModal).keyup(function() {
                    $('.new-url', vm.createUrlRedirModal).addClass('hide');
                });
            },
            requestDataLinkGenerators: async function (){
                this.loading = true
                try{
                    let res = await axios.get(`/${this.lang}/office/franchise-system/link-generators/data`)
                    res = res.data.data
                    this.$set(this.$data, 'view', res)
                } catch(e) {
                    console.log('error = ', e.getMessage())
                } finally {
                    this.loading = false
                }
            }
        },
        mounted() {
            $('#createUrlRedirModal').on('show.bs.modal', this.init)
        }
    }
</script>

<style scoped lang="scss">
    .modal-content{
        width: 45%;
        .modal-header{
            .close{
                color: #C4C4C4 !important;
            }
            .modal-title{
                font-size: 22px !important;
            }
        }
        .modal-body{
            padding-top: 0 !important;
            input::placeholder{
                font-weight: 200;
            }
        }
        .box-inputs{
            .box-btn-link{
                background-color: #EDF1F7;
                border-radius: 5px;
                padding: 1em;
                display: flex;
                flex-direction: column;
                flex-wrap: wrap;
                align-items: center;
                justify-content: space-between;
                label{
                    font-size: .8em !important;
                }
                .box-input-copy{
                    width: 100%;
                }
                .btn-generator{
                    width: 100%;
                    z-index: 1;
                    position: relative;
                    border: none;
                    padding: 0.43em !important;
                    /* svg{
                        color: #02EAA0;
                        animation-name: svgSuccess;
                        animation-duration: 1s;
                    } */
                }
                .btn-generator::before{
                    position: absolute;
                    border-radius: 8px;
                    z-index: -1;
                    content: '';
                    top: 0;
                    left: 0;
                    bottom: 0;
                    right: 0;
                    transform: scaleX(0);
                    transition: transform .8s ease-in-out;
                    transform-origin: left;
                    background-color: #0763cc;
                }
                .btn-generator:focus::before{
                    transform: scaleX(1);
                }
            }
        }
    }
    .valid{
        border: 1px solid #0072E1 !important;
    }
    .select-grid{
        width: 100%;
        display: grid;
        /* select{
            height: 100%!important;
            border-radius: 0.7em;
            color: #A5B9D5;
            cursor: pointer;
            border: 1px solid #A5B9D5;
        } */
        /* .fs5-btn{
            border-radius: 8px!important;
            height: 1em;
        } */
        .button-copy-shorter-link{
          border: none;
          background: none;

            builderall-icon{
            --builderall-icon-size: 22px;
            --builderall-icon-color: #425E7D;
          }
        }
        #share-url-input-hidden-mini{
            opacity: 0;
            height: 0.1px;
        }
    }
    .short-url-loading {
      display: flex;
      align-items: center;
      flex-direction: column;
      img {
        width: 30px;
      }
      /* span {
        font-size: 0.75em;
        display: flex;
        align-items: center;
        gap: 0.4em;
        border-radius: 50px;
        padding: 0.3em 0.7em;
        background: linear-gradient(to bottom right, #ede2e2, #fff0f0);
        margin-top: 0.5em;
        img {
          width: 0.75em;
        }
      } */
    }
    @media only screen and (max-width: 780px) {
        .modal-title{
            font-size: 1.3em !important;
        }
    }
    @media only screen and (max-width: 500px) {
        .select-grid{
            display: flex;
            flex-direction: column;
            select{
                margin-bottom: 0.5em;
            }
        }
    }
    @keyframes svgSuccess {
        from {transform: rotate(0deg);}
        to {transform: rotate(360deg);}
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/modals/RedirectLink.vue